import withInjectedProps from '@atlassian/jira-common-util-with-injected-props/src/index.tsx';
import Breadcrumb from '../../breadcrumb/component.tsx';
import BoardBreadcrumb from '../../common-breadcrumbs/board/view.tsx';
import ProjectBreadcrumb from '../../common-breadcrumbs/project/index.tsx';
import UserBreadcrumb from '../../common-breadcrumbs/user/view.tsx';
import LegacyBreadcrumbConnector from './component.tsx';
import ContextProvider from './context-provider/index.tsx';

export default withInjectedProps(LegacyBreadcrumbConnector, {
	Breadcrumb,
	ProjectBreadcrumb,
	// @ts-expect-error - TS2322 - Type '{ ({  children, boardId, boardName, isSimplifiedProject, projectId, }: BoardBreadcrumbProps): JSX.Element; defaultProps: { children: null; isSimplifiedProject: boolean; projectId: undefined; }; }' is not assignable to type 'ComponentType<Partial<BoardBreadcrumbProps>> | undefined'.
	BoardBreadcrumb,
	UserBreadcrumb,
	ContextProvider,
});
